export const FooterInfo = [
  {
    title: "Explore",
    links: [
      {
        text: "Sign In ↗",
        link: "/login",
      },
      {
        text: "Terms ↗",
        link: "/terms",
      },
      {
        text: "FAQ ↗",
        link: "/faq",
      },
      {
        text: "All Services ↗",
        link: "/services",
      },
    ],
  },
  {
    title: "Services",
    links: [
      {
        text: "Facebook ↗",
        link: "",
      },
      {
        text: "Youtube ↗",
        link: "",
      },
      {
        text: "Instagram ↗",
        link: "",
      },
      {
        text: "Twitter ↗",
        link: "",
      },
    ],
  },
  {
    title: "Follow us",
    links: [
      {
        text: "Instagram ↗",
        link: "",
      },
      {
        text: "Telegram ↗",
        link: "",
      },
    ],
  },
];
